<template>
    <comp-9-prep-adherence :section="9" :page="38" :nextDisabled="nextDisabled" :next="nextScreen">
        <p>
            Now, let’s do a little daydreaming. Imagine, it’s 30 days from now and we pop this question again. How would you respond then?
        </p>
        <p>
            Thinking about the last 30 days, how often did you take PrEP?
        </p>
        <v-radio-group v-model="prepAdherenceSelection" column>
            <v-radio v-for="adherence in prepAdherences" :key="adherence.id" :label="adherence.text" :value="adherence"></v-radio>
        </v-radio-group>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            prepAdherenceSelection: null
        };
    },
    computed: {
        prepAdherence() {
            let selectedPrepAdherence = find(this.prepAdherences, 'selected');

            if (selectedPrepAdherence) {
                return selectedPrepAdherence;
            } else return null;
        },
        prepAdherences: sync('section9/prepAdherenceRevisited'),
        nextScreen() {
            if (this.prepAdherenceSelection) {
                return `/page/9/${this.prepAdherenceSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.prepAdherenceSelection;
        }
    },
    watch: {
        prepAdherenceSelection(newPrepAdherenceSelection) {
            forEach(this.prepAdherences, o => {
                if (o.id === newPrepAdherenceSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.prepAdherenceSelection = this.prepAdherence;
    }
};
</script>
